import ModalWelcome from './ModalWelcome';

export default ModalWelcome;
